
























































































































































































import { log } from 'console';
import Vue from 'vue';
import { VueEditor, Quill } from "vue2-editor";

export default Vue.extend({

   components: {
    VueEditor
  },
  data() {
    return {
      forumId : '',
      msg : false,
      recruiter: {},
      forumDetailsData :{},
      content: "",
      likeData :false,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["image", "code-block", "video", "link"]
      ]
    };
  },
  async created(){
    this.forumId = this.$route.params.id;
    this.forumDetails();
  },
  
  methods: {
    async forumDetails(){
      let token =  localStorage.getItem("jwt");
      let userId = localStorage.getItem("userId");
      if (token) {
        const auth = {
          headers: {authorization: token} 
        }   
        let res = await this.$http.get('/community/fetchSpecificCommunityPost/'+this.forumId,auth);
        if (res.status == 200) {
          this.forumDetailsData = res.data.community;
        }
        console.log('forumDetailsData', this.forumDetailsData);

        let recruiter_details = await this.$http.get('/job/fetchRecruiterDetails/'+userId,auth);
        if (recruiter_details.status == 200) {
          this.recruiter = recruiter_details.data.recruiter;
        } 
      }
    },
    async postComment(){
      if (this.content ==='') {
        this.msg = true;
      }
      else{
        this.msg = false;
        let token =  localStorage.getItem("jwt");
        let userId = localStorage.getItem("userId");
        if (token) { 
          const auth = {
            headers: {authorization: token} 
          } 
          
          let postData = {
            'community_id':this.forumId,
            'user_id' : userId,
            'user_name' : this.recruiter.name,
            'user_avtar_url' :this.recruiter.profile_image_url,
            'user_comment': this.content.replace(/<\/?[^>]+(>|$)/g, "")
          }
          let res = await this.$http.post('/community/commentPost',postData,auth);
            console.log('res',res);
            
            if (res.status === 200 && res.data.message) {
              this.content='';
              this.forumDetails();
            }
        }
      }
    },
    async deleteF(forumId){
      try {
        this.$swal({
          title: 'Remove Forum',
          text: 'Are you sure?',
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          cancelButtonText:'Cancel',
          customClass: 'swal-title-jobapplication'
        }).then((result) => {
          if (result.isConfirmed) {
            this.delete_Forum(forumId);
          }         
        })
      }catch(error){}
    },

    async delete_Forum(id){
      let token = localStorage.getItem("jwt");
      let userId = localStorage.getItem("userId");
      if (token && userId) { 
        const auth = {
          headers: {authorization: token} 
        }  
        let res = await this.$http.post('/community/deleteCommunityPost',{
          coomunity_id: id,
          user_id: userId
        },auth);
        console.log(res);
        
        if (res.status === 200 && res.data.message) {
          console.log("jhjhggyugyggygy");
          this.snackbar = true;
          this.showMessage = 'Removed Successfully.'
          this.$router.push({ name: 'Forum' })
        } else {
          this.snackbar = true;
          this.showMessage = 'Something wrong! Please try again.'
        }
      }
    },

    async deleteComment(cID,fID){
       try {
        this.$swal({
          title: 'Remove Comment',
          text: 'Are you sure?',
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          cancelButtonText:'Cancel',
          customClass: 'swal-title-jobapplication'
        }).then((result) => {
          if (result.isConfirmed) {
            this.del_Comment(cID,fID);
          }         
        })
      }catch(error){}
    },

    async del_Comment(cID,fID){
      let token = localStorage.getItem("jwt");
      if (token) { 
        const auth = {
        headers: {authorization: token} 
      }  
      let res = await this.$http.post('/community/deleteComment',{
        community_id: fID,
        comment_id: cID
      },auth);
        console.log(res);        
        if (res.status === 200 && res.data.message) {
          this.forumDetails();
        } else {
          this.snackbar = true;
          this.showMessage = 'Something wrong! Please try again.'
        }
      }
    },
    backPage() {
      window.history.back()
    },

    async like(forumId){
      this.likeData = !this.likeData;
      // this.likeData = false;
      let like : any;
      let  likeId : '';
      console.log('this.likeData',this.likeData);
      let token =  localStorage.getItem("jwt");
      let userId = localStorage.getItem("userId");console.log('u',userId);
      if (token) { 
        const auth = {
          headers: {authorization: token} 
        } 
        this.forumDetailsData.liked_by.forEach(element => {
          console.log('element user_id',element.user_id);
          console.log('user_id',userId);
          if(element.user_id == userId){
            likeId = element._id;
          }
        })
        console.log('likeId',likeId);
        if (likeId != undefined) {
          let disLike = {
            'community_id':forumId,
            'liked_id' : this.likeId
          }
          let resLike = await this.$http.post('/community/dislikePost',disLike,auth);
            if (resLike.status === 200){
              this.forumDetails()
            }
        }
        else{
          console.log('like');
          like={
            'community_id':forumId,
            'user_id':userId,
            'user_name':this.forumDetailsData.creator_name,
            'user_avtar_url': this.forumDetailsData.creator_avtar_url
          }
          console.log('like',like);
          let resLike = await this.$http.post('/community/likePost',like,auth);
            console.log('resLike',resLike);
          if (resLike.status === 200){
            this.forumDetails()
          }
        }     
      }
    }
  }
})
